export const JWT_TOKEN = 'exr_token';
export const REFRESH_TOKEN = 'refresh_token';
export const PROD_ENT = 'prod_ent';
export const SESSION = 'session';
export const REGISTER = 'register';
export const QUEUE = 'queue';
export const OFFLINE_ID = 'offineId';
export const STATE_SLICE = 'state_slice';
export const DEFAULT_PAGE_SIZE = 100; // hide paging for now load it all
export const DEFAULT_TOAST_DELAY = 15000;
export const DEBOUNCE_UPDATE = 1000;
// How long an answered action stays on screen before the player advances.
export const FEEDBACK_DELAY = 700;
// Longer window for actions with `visualFeedback` on: the correct answer is
// highlighted after selection, so the learner needs time to actually read it.
// The marks and labels take ~600ms to finish animating in (see .answer-mark-in
// in css/main.css), so the readable part of the window is what is left after
// that — a learner comparing their pick against the right answer on a
// multi select needs most of it. Anything that races the answer saga's advance
// must outlast this — see RESULT_ADVANCE_GRACE in
// core/sagas/product/progress/response.ts.
export const VISUAL_FEEDBACK_DELAY = 5000;
